module.exports = __webpack_public_path__ + "static/esco-2-c5a3c8e936a9ae9a1f3806407f80799e.jpeg";